import { createContext, useReducer } from "react";

export const PhilosophyListContext = createContext();

export const philosophyListReducer = (state, action) => {
    switch (action.type) {
        case 'SET_PHILOSOPHY_LIST':
            return {
                philosophyList: action.payload
            }
        case 'CREATE_PHILOSOPHY_LIST':
            return {
                philosophyList: [action.payload, ...state.philosophyList]
            }
        case 'DELETE_PHILOSOPHY_LIST':
            return {
                philosophyList: state.philosophyList.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const PhilosophyListContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(philosophyListReducer, {
        philosophyList: null
    });

    return (
        <PhilosophyListContext.Provider value={{ ...state, dispatch }}>
            {children}
        </PhilosophyListContext.Provider>
    );
};